export const translateStatusString = (string, currentLanguage = "EN") => {
  string.toLowerCase();
  switch (string) {
    case "completed":
      return currentLanguage === "EN"
        ? "Completed"
        : currentLanguage === "IT"
        ? "Completato"
        : "Completed";
    case "active":
      return currentLanguage === "EN"
        ? "Active"
        : currentLanguage === "IT"
        ? "Attivo"
        : "Active";
    case "pending":
      return currentLanguage === "EN"
        ? "Pending"
        : currentLanguage === "IT"
        ? "In attesa"
        : "Pending";
    case "failed":
      return currentLanguage === "EN"
        ? "Failed"
        : currentLanguage === "IT"
        ? "Fallito"
        : "Failed";
    case "new":
      return currentLanguage === "EN"
        ? "New"
        : currentLanguage === "IT"
        ? "Nuovo"
        : "New";
    case "refunded":
      return currentLanguage === "EN"
        ? "Refunded"
        : currentLanguage === "IT"
        ? "Rimborsato"
        : "Refunded";
    case "in_progress":
      return currentLanguage === "EN"
        ? "In Progress"
        : currentLanguage === "IT"
        ? "In corso"
        : "In Progress";
    case "open":
      return currentLanguage === "EN"
        ? "Open"
        : currentLanguage === "IT"
        ? "Aperto"
        : "Open";
    case "closed":
      return currentLanguage === "EN"
        ? "Closed"
        : currentLanguage === "IT"
        ? "Chiuso"
        : "Closed";

    default:
      return string;
  }
};
